import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SimpleBarScroll from "components/SimpleBar";
import ProductValidationCreate from "pages/product_validation/ProductValidationCreate";
import React from "react";

const ProductValidationUpdateDialog = ({ open, handleClose, validation }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading="Edit validation"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <ProductValidationCreate
              productValidation={validation}
              fullGrid={false}
            />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  );
};

export default ProductValidationUpdateDialog;
